const numberMetrics = [
  "metric_type_wpm",
  "metric_type_freq300",
  "metric_type_snr",
  "metric_type_ai_delay",
  "metric_type_time_to_first_audio",
  "metric_type_phonemes_per_second",
  "metric_type_pauses",
  "metric_type_time_to_first_audio",
  "metric_type_volume",
  "metric_type_interruption_detection",
  "metric_type_vocal_fry",
]

const NUMERICAL_MANAGERS = [
  "manager_numerical_llm_judge",
  "manager_audio_llm_numerical",
  "manager_latency",
  "manager_signal_to_noise_ratio",
  "manager_time_to_first_audio",
  "manager_transcription_error",
  "manager_words_per_message",
  "manager_abrupt_pitch_changes",
  "manager_pitch_variability",
  "manager_lufs",
  "manager_terminal_contour",
  "audio_duration_metric_manager",
  "manager_audio_frequency",
  "manager_non_expressive_pauses",
  "pause_analysis_metric",
  "manager_phonemes_per_second",
  "manager_spectrogram_pitch_analysis",
  "manager_vocal_fry",
  "manager_volume_pitch_misalignment",
  "manager_volume",
  "interruption_rate_manager",
  "manager_music_detection",
]

export const isNumberMetric = (metric_name: string) => {
  return numberMetrics.includes(metric_name)
}

export const isNumberMetricByManager = (metric: { metric_manager: string }) => {
  return NUMERICAL_MANAGERS.includes(metric.metric_manager)
}
